import _replace from "lodash/replace"
import _startsWith from "lodash/startsWith"

export const isMatchingPath = (currentPath, basePath) => {
  if (!basePath || basePath === "/") return currentPath === basePath

  return _startsWith(normalizePath(currentPath), normalizePath(basePath))
}

const normalizePath = (path) => _replace(path, /\/$/, "")



// WEBPACK FOOTER //
// ./src/services/utils/isMatchingPath.js